module.exports = "/images/LTRL banner mobile v2.0.jpg?7c0e8f577703200c8ec87d171ee30ca2";